import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth';
import stat from './modules/stat';
import websocket from './modules/websocket';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    stat,
    websocket,
  },
});
